import {handleError, handleResponse} from "./apiUtils";

const baseUrl = "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/";

async function parseJsonBody(response) {
  const rawResponse = await response.text();
  if (!rawResponse) {
    return null;
  }

  try {
    return JSON.parse(rawResponse);
  } catch (error) {
    return rawResponse;
  }
}

function signUp(user) {
  return fetch(`${baseUrl}users/${user.id}`, {
    method: "PUT",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(user),
  })
    .then(handleResponse)
    .catch(handleError);
}

function signIn(user) {
  return fetch(`${baseUrl}login`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(user),
  })
    .then(handleResponse)
    .then((response) => {
      localStorage.token = response.token;
      return response.user;
    })
    .catch(handleError);
}

async function signInWithGoogle(token) {
  const response = await fetch(`${baseUrl}login/google`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ token }),
  });

  const payload = await parseJsonBody(response);

  if (!response.ok) {
    const message = typeof payload === "string"
      ? payload
      : `Network response was not ok. status:${response.status}`;
    throw new Error(message);
  }

  localStorage.token = payload.token;
  return payload.user;
}

export default {
  signUp,
  signIn,
  signInWithGoogle,
};
